import React from 'react'
import { Link } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { NoteLabelProps } from './useNoteLabelModel'

export const NoteLabelLegacy: React.FC<NoteLabelProps> = props => {
  return (
    <Link
      className="vd-text-label pro-sale-note-link sale-total-header--link"
      href="#"
      onClick={props.onClick}
      data-track="sale-note-link"
    >
      <T _str="Note" _context="Note link on sale footer" />
    </Link>
  )
}
